<template>
  <div>
    <ly-dialog
      v-model="dialogVisible"
      :title="loadingTitle"
      width="560px"
      @closed="handleClose"
    >
      <el-form
        :inline="false"
        :model="formData"
        :rules="rules"
        ref="rulesForm"
        label-position="right"
        label-width="auto"
      >
        <el-form-item label="用户头像：">
          <LyUploadAvatar
            v-model="formData.avatar"
            width="100px"
            height="100px"
          ></LyUploadAvatar>
        </el-form-item>
        <el-form-item label="用户名：" prop="username">
          <el-input v-model="formData.username"></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称：" prop="nickname">
          <el-input v-model="formData.nickname"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model="formData.password" clearable show-password></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model="formData.mobile"></el-input>
        </el-form-item>

        <el-form-item label="状态：" prop="is_active">
          <el-switch
            v-model="formData.is_active"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
        <el-button type="primary" @click="submitData" :loading="loadingSave"
          >确定</el-button
        >
      </template>
    </ly-dialog>
  </div>
</template>

<script>
import { UsersUsersAdd, UsersUsersEdit } from "@/api/api";
import LyDialog from "@/components/dialog/dialog";
import LyUploadAvatar from "@/components/upload/avatar";
import { buildTree } from "@/utils/util.js";
import { columnGet } from "@/api/court";
export default {
  name: "addUser",
  components: {
    LyDialog,
    LyUploadAvatar,
  },
  emits: ["refreshData", "closed"],
  data() {
    return {
      dialogVisible: false,
      loadingSave: false,
      loadingTitle: "",
      defaultImg: require("../../../assets/img/avatar.jpg"),
      formData: {
        username: "",
        nickname: "",
        mobile: "",
        is_active: true,
				is_staff: true,
				identity: 2,
        avatar: "",
        managed_columns: [],
      },

      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        is_active: [
          {
            required: true,
            message: "请选择是否启用",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("closed");
    },
    handleOpen(item, flag) {
      this.loadingTitle = flag;
      this.dialogVisible = true;
      if (item) {
        delete this.rules.password;
        this.formData = item;
      } else {
        this.rules.password = [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ];
        this.formData = {
          name: "",
          nickname: "",
          username: "",
          mobile: "",
          is_active: true,
          avatar: "",
          managed_columns: [],
					is_staff: true,
					identity: 2
        };
      }
    },
    submitData() {
      this.$refs["rulesForm"].validate((obj) => {
        if (obj) {
          this.loadingSave = true;
          let param = {
            ...this.formData,
          };

          if (this.formData.id) {
            UsersUsersEdit(param).then((res) => {
              this.loadingSave = false;
              if (res.code == 2000) {
                this.$message.success(res.msg);
                this.dialogVisible = false;
                this.handleClose();
                this.$emit("refreshData");
              } else {
                this.$message.warning(res.msg);
              }
            });
          } else {
            UsersUsersAdd(param).then((res) => {
              this.loadingSave = false;
              if (res.code == 2000) {
                this.$message.success(res.msg);
                this.handleClose();
                this.$emit("refreshData");
              } else {
                this.$message.warning(res.msg);
              }
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped></style>
